const ADS_LIST_RENTING_BREADCRUMB_FIELDS = {
  COMMITMENT_MONTHS: 'commitmentMonths',
  VEHICLE_STATE: 'vehicleState',
  ENTRY_FEE: 'entryFee',
  TARGET_BUYER: 'targetBuyer',
  SECTION_3: 'section3'
}
// Key order defines the order of the breadcrumbs output
export const ADS_LIST_BREADCRUMB_FIELDS = {
  SECTION: 'section',
  SECTION_2: 'section2',
  MAKE: 'make',
  MODEL: 'model',
  VERSION: 'version',
  FUEL_TYPE: 'fuelType',
  BODY_TYPE: 'bodyType',
  PROVINCE: 'province',
  CITY: 'city',
  REGION: 'region',
  ...ADS_LIST_RENTING_BREADCRUMB_FIELDS,
  COLOUR: 'colour',
  SELLER_TYPE: 'sellerType',
  SEATING_CAPACITY: 'seatingCapacity',
  TRANSMISSION_TYPE: 'transmissionType',
  YEAR: 'year',
  PRICE_RANGE_GROUP: 'priceRangeGroup',
  CATEGORY_2: 'category2',
  CUBIC_CAPACITY: 'cubicCapacity'
}
export const ADS_LIST_BREADCRUMBS_MAP = Object.values(ADS_LIST_BREADCRUMB_FIELDS)
